module.exports = __webpack_public_path__ + "src/assets/img/modalcard.a96fc2f2.png";